export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000,
} as const;

export const WALKING_TIME_THRESHOLD_MINUTES = 15;

export const ADD_STAY_SEARCH_PARAM_KEY = 'addStay';
